export default __webpack_public_path__ + "static/realWorldImg4-d5fe9dec8467e9ebbbb04756e87419ec.png";